import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { useMemo, useState } from "react";
import { ButtonWrapper } from "styles/ModalCommonStyled";
import BigButton from "components/atoms/buttons/BigButton";
import SuccessKey from "../generateKey/component/SuccessKey";
import ConfirmKeyInfo from "../generateKey/component/ConfirmKeyInfo";
import {
  KeyInfo,
  PostCpCheckoutCompleteResponse,
  SubscriptionKeyListType,
} from "api/interfaces/subscription.interface";
import useStatusMutation from "hook/useStatusMutation";
import { postReplaceKey } from "api/subscriptionAPI";
import { CustomError } from "api/interfaces/commonInterface.interface";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import useApiError from "hook/useApiError";

type Props = {
  keyInfo: SubscriptionKeyListType;
  onModal: () => void;
  refetch: () => void;
};

export default function ReplaceKeyModal(props: Props): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { handleErrorNotify, notifySuccess, lang } = useApiError();

  const [isSuccessKey, setIsSuccessKey] = useState<false | string[]>(false);

  const keyInfo: KeyInfo = useMemo(() => {
    return {
      keyType: props.keyInfo.type,
      duration: props.keyInfo.duration,
      number: props.keyInfo.purchased,
      qty: 1,
    };
  }, [props.keyInfo]);

  const mutationReplaceKey = useStatusMutation(postReplaceKey, {
    onSuccess: (res: PostCpCheckoutCompleteResponse) => {
      notifySuccess(lang.label.subscription.replace.success);
      setIsSuccessKey(res.result);
      props.refetch();
    },
    onError: (err: CustomError) => {
      handleErrorNotify(err, lang.label.subscription.replace.fail);
    },
  });

  const onMutateReplaceKey = () => {
    mutationReplaceKey.mutate({
      accountId: selectedAccount.accountId,
      payload: { key: props.keyInfo.dwKey, keyType: keyInfo.keyType },
    });
  };

  return (
    <BigPopupTemplate title="Replace Key" onModal={props.onModal}>
      {isSuccessKey ? (
        <SuccessKey successKeyList={isSuccessKey} />
      ) : (
        <ConfirmKeyInfo
          isReplace={props.keyInfo.dwKey}
          keyInfo={keyInfo}
          cost={{ monthlyCost: 0, totalCost: 0 }}
          validateMsg=""
        />
      )}

      <ButtonWrapper>
        {isSuccessKey ? (
          <BigButton
            label={"Close"}
            buttonType={"cancel"}
            onClickBtn={() => {
              props.onModal();
            }}
            data-testid="subscription-modal-replace-key-button-modal"
          />
        ) : (
          <>
            <BigButton
              label={"Cancel"}
              buttonType="cancel"
              onClickBtn={() => {
                props.onModal();
              }}
              data-testid="subscription-modal-replace-key-button-modal-2"
            />

            <BigButton
              label={"Replace"}
              onClickBtn={() => {
                onMutateReplaceKey();
              }}
              data-testid="subscription-modal-replace-key-button-mutate-replace-key"
            />
          </>
        )}
      </ButtonWrapper>
    </BigPopupTemplate>
  );
}
